module.exports = __webpack_public_path__ + "static/media/background-vantagens@2x.70b21199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-vantagens@2x.png
// module id = 402
// module chunks = 0